import React from 'react';

export type SquadFilterValue = 'all' | 'Multi Marcas' | 'Casas Bahia';

interface SquadFilterProps {
  value: SquadFilterValue;
  onChange: (value: SquadFilterValue) => void;
}

export const SquadFilter: React.FC<SquadFilterProps> = ({ value, onChange }) => {
  const options: { value: SquadFilterValue; label: string }[] = [
    { value: 'all', label: 'Todos' },
    { value: 'Multi Marcas', label: 'Multi Marcas' },
    { value: 'Casas Bahia', label: 'Casas Bahia' },
  ];

  return (
    <div className="flex gap-2">
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`px-5 py-3 rounded-2xl font-medium text-sm transition-all duration-300 ${
            value === option.value
              ? 'bg-warm-400 dark:bg-dark-purple-300 text-soft-black dark:text-white shadow-soft'
              : 'bg-white dark:bg-dark-200 text-soft-gray dark:text-gray-300 border-0 shadow-soft hover:bg-warm-200 dark:hover:bg-dark-400 hover:shadow-soft-lg'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
